<!-- 商品详情 -->
<template>
	<div class="wrap">

		<div class="container-wrap">
			<div class="content-width">

				
				<header-search  hideModel="2"></header-search>

				<div class="middle-module">
					<div class="middle-leftsidebar">
						<div class="middle-leftsidebar-top">
							<div class="big-img-box">
								<img :src="info.cover" class="big-img">
							</div>
							<div class="seckill-module" v-if="actType == 1 && seckill">
							<!-- <div class="seckill-module" v-if="actType == 1 && seckill"> -->
								<div class="seckill-module-leftsidebar">
									秒杀价:
									<span class="seckill-price">¥{{info.low_seckill}}</span>
									<span class="seckill-del-price">¥{{info.max_price}}</span>
								</div>
								<div class="seckill-module-rightsidebar">
									<span class="seckill-label" v-if="activeStatus == 0">距秒杀始时间</span>
									<span class="seckill-label" v-if="activeStatus == 1">距秒杀截止时间</span>
									<span class="seckill-label" v-if="activeStatus == -1">秒杀已结束</span>
									<div class="countdown-wrap">
										<span class="day-name" v-if="parseInt(timeData.d) > 0">{{timeData.d}}天</span>
										<div class="countdown">
											<span>{{timeData.h}}</span>
											<span>:</span>
											<span>{{timeData.m}}</span>
											<span>:</span>
											<span>{{timeData.s}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- <div class="middle-leftsidebar-bottom">
							<ul class="small-img-list">
								<li>  
									<img src="../../assets/banner-7.png" class="small-img">
								</li> 
								<li>
									<img src="../../assets/banner-7.png" class="small-img">
								</li>
								<li>
									<img src="../../assets/banner-7.png" class="small-img">
								</li>
								<li>
									<img src="../../assets/banner-7.png" class="small-img">
								</li>  
							</ul>
						</div> -->
					</div>
					<div class="middle-rightsidebar">
						<p class="product-name">{{info.name}}</p>
						<div class="card">
							<p class="card-row">
								<span class="card-row-label">价格</span>
								<!-- 默认价格 -->
								<!-- ￥{{info.max_price}} -->
								<!-- 规格价格 -->
								￥{{itemSelect.original_price}}
							</p>
							<div class="card-row-between">
								<p class="card-row">
									<span class="card-row-label">促销价</span>
									<span class="card-row-price">
										<!-- 默认价格 -->
										<!-- ￥<span>{{info.low_price}}</span> -->
										<!-- 规格价格 -->
										￥<span>{{itemSelect.sell_price}}</span>
									</span>
								</p>
								<div class="return-box" v-if="info.share_money > 0">
									<span class="return-left">返</span>
									<span class="return-right">￥<span>{{info.share_money}}</span></span>
								</div>
							</div>
						</div>
						<!-- <div class="address-module">
							<p class="address-label">配送地址</p>
							<div class="address-box">
								<img src="../../assets/location-icon.png" class="location-icon">
								<p class="address-msg">山东省 临沂市 兰山区 柳青街道 </p>
								<span class="courier">快递:免运费</span>
							</div>
						</div> -->
						<div class="radio-box" v-for="(item, index) in itemList.list" :key="index">
							<p class="radio-label">{{item[0]}}</p>
							<ul class="nav-list">
								<li v-for="(item2, index2) in item[1]" :key="index2"
									:class="{active: itemListSelect[item[0]] == item2}"
									@click="chooseItem(item[0], item2)">
									{{item2}}
								</li>
							</ul>
						</div>
						<div class="box-between">
							<div class="box-between-left">
								购买数量
								<span>
									<!-- (限购10件) -->
									库存{{itemSelect.stock}}件
								</span>
							</div>
							<el-input-number v-model="num" :min="1" :max="itemSelect.stock"></el-input-number>
						</div>
						<div class="btn-box">
							<button type="button" class="border-red-btn"
								@click="userCollect(info.id, info.first_classify)">
								<img src="../../assets/collect.png" class="collect-icon">
								收藏
							</button>
							<button type="button" class="orange-btn" @click="addCart()">加入购物车</button>
							<button type="button" class="red-btn" @click="buy()">立即购买</button>
						</div>
						<div class="tag-box">
							<label class="tag-label">保障</label>
							<div class="tag-rightsidebar">
								<span v-for="(item, index) in info.serve_title" :key="index">{{item}}</span>
							</div>
						</div>
					</div>
				</div>

				<div class="group-module" v-if="groupLeaderList.length > 0">
					<div class="group-module-top">
						{{groupLeaderList.length}}人在拼单，可直接参与
					</div>
					<div class="group-msg-list">
						<div class="group-msg-item" v-for="(item, index) in groupLeaderList" :key="index">
							<div class="group-msg-sidebar">
								<img :src="item.headimg" class="group-user-img">
								<div class="group-user-name">
									{{item.name}}
								</div>
							</div>
							<button type="button" class="group-btn">去拼单</button>
						</div>
					</div>
				</div>

				<div class="bottom-module">
					<ul class="tab-list">
						<li v-for="(item,index) in tabList" :class="{active:tabId==index}" @click="tabId=index"
							:key="index">
							<a href="javascript:void(0)">{{item.title}}</a>
						</li>
					</ul>
					<div v-show="tabId == 0">
						<div class="product-details-module">
							<div class="product-details-top">
								<div class="product-details-row">
									<label class="product-details-label">产品功效</label>
									<div class="product-details-msg-list">
										<span v-for="(item, index) in info.effect_arr" :key="index">{{item}}</span>
										<!-- <span>健胃润肠</span> -->
									</div>
								</div>
								<!-- <div class="product-details-row">
									<label class="product-details-label">品牌</label>
									<div class="product-details-msg-list">
										<span>程老伯</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">适合人群</label>
									<div class="product-details-msg-list">
										<span>亚健康</span>
										<span>心血管患者</span>
										<span>糖尿病患者</span>
										<span>体弱多病</span>
										<span>消化不良</span>
										<span>心血管患者</span>
										<span>糖尿病患者</span>
										<span>体弱多病</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">价格</label>
									<div class="product-details-msg-list">
										<span>0-50元</span>
									</div>
								</div> -->
								<div class="product-details-row">
									<label class="product-details-label">有效搭配</label>
									<div class="product-details-msg-tag-list">
										<span v-for="(item, index) in info.goods_match_arr" :key="index">{{item}}</span>
										<!-- <span>乌鸡</span>
										<span>乌鸡</span> -->
									</div>
								</div>
								<div class="product-details-row" v-for="(item, index) in info.goods_param || []"
									:key="index">
									<label class="product-details-label">{{item.title}}</label>
									<div class="product-details-msg-list">
										<span>{{item.value}}</span>
									</div>
								</div>
								<!-- <div class="product-details-row">
									<label class="product-details-label">产地</label>
									<div class="product-details-msg-list">
										<span>中国大陆</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">发货</label>
									<div class="product-details-msg-list">
										<span>北京携手熊猫总部</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">省份</label>
									<div class="product-details-msg-list">
										<span>山东省</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">源头</label>
									<div class="product-details-msg-list">
										<span>中国大陆</span>
										<a href="javascript:void" class="red-color-border">产品可溯源</a>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">时令</label>
									<div class="product-details-msg-list">
										<span>6月/7月/8月</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">同城服务</label>
									<div class="product-details-msg-list">
										<span>同城24小时物流送货上门</span>
									</div>
								</div> -->
								<div class="product-details-row">
									<label class="product-details-label">保障</label>
									<div class="product-details-msg-list">
										<span v-for="(item, index) in info.serve_title" :key="index">{{item}}</span>
										<!-- <span>七天无理由退换</span> -->
									</div>
								</div>
								<!-- <div class="product-details-row">
									<label class="product-details-label">包装方式</label>
									<div class="product-details-msg-list">
										<span>包装</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">参数</label>
									<div class="product-details-msg-list">
										<span>生产日期</span>
										<span>产地</span>
										<span>净含量…</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">套餐周期</label>
									<div class="product-details-msg-list">
										<span>1周</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">售卖方式</label>
									<div class="product-details-msg-list">
										<span>单品</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">配送频次</label>
									<div class="product-details-msg-list">
										<span>1周2次</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">套餐份量</label>
									<div class="product-details-msg-list">
										<span>5人份</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">净含量</label>
									<div class="product-details-msg-list">
										<span>500g 1500g 2500g</span>
									</div>
								</div>
								<div class="product-details-row">
									<label class="product-details-label">厂址</label>
									<div class="product-details-msg-list">
										<span>山东烟台</span>
									</div>
								</div> -->
							</div>
						</div>
						<img v-for="(item, index) in info.content_arr" :key="index" :src="item" class="picture">
					</div>
					<div v-show="tabId == 1">
						<div class="evaluation-module">
							<div class="evaluation-top">
								<span class="evaluation-num">全部评价{{commentTotal}}条</span>
								<!-- <ul class="evaluation-tag-list">
									<li>口味鲜美多汁</li>
									<li>很好吃</li>
									<li>还会再买</li>
								</ul> -->
							</div>
							<ul class="evaluation-list">
								<li v-for="(item, index) in commentList" :key="index">
									<div class="evaluation-leftsidebar">
										<div class="evaluation-leftsidebar-top">
											<img :src="item.user.headimg" class="people-avatar">
											<p class="people-name">{{item.user.name}}</p>
										</div>
										<el-rate v-model="item.goods_core" disabled
											:colors="['#F64016', '#F64016', '#F64016']">
											disabled-void-color="#C2C2C2">
										</el-rate>
										<span class="date-time">{{item.create_at}}</span>
									</div>
									<div class="evaluation-rightsidebar">
										<p class="evaluation-msg">
											{{item.content}}
										</p>
										<div class="img-list">
											<img src="../../assets/img-red.png" class="img" v-for="(val, index) in 5"
												:key="index" v-show="item.goods_core > index">
											<!-- <img src="../../assets/img-red.png" class="img">
											<img src="../../assets/img-red.png" class="img"> -->
										</div>
									</div>
								</li>
								<!-- 无数据显示 -->
								<div class="normal-box" v-if="commentList.length == 0">
									<img src="../../assets/normal-9.png">
									暂无评论
								</div>
							</ul>
						</div>
						<div class="box-end">
							<el-pagination background layout="prev, pager, next" :total="1000">
							</el-pagination>
						</div>
					</div>
				</div>

			</div>
		</div>

		<!-- <div class="bb">
			<div>
				<div class="choose">
					<div class="content" @mousemove="handleMove" @mouseout="handleOut">
						<img src="../../assets/bg-1.png" id="small">
						<div class="shadow"></div>
					</div>
					<ul id="listshow">
						<li class="selected">
							<img src="../../assets/bg-1.png" data-img="../../assets/bg-1.png" alt="">
						</li>
						<li>
							<img src="../../assets/bg-10.png" data-img="../../assets/bg-10.png" alt="">
						</li>
						<li>
							<img src="../../assets/bg-3.png" data-img="../../assets/bg-3.png" alt="">
						</li>
						<li>
							<img src="../../assets/bg-5.png" data-img="../../assets/bg-5.png" alt="">
						</li>
					</ul>
				</div>
				<div class="larger">
					<img src="../../assets/bg-1.png" id="big">
				</div>
			</div>
		</div> -->

	</div>
</template>
<script>
	// 轮播新增 start
	import {
		Swiper,
		SwiperSlide
	} from 'vue-awesome-swiper';
	import 'swiper/css/swiper.css'
	import {
		expediteGetGoodsComment,
		expediteGetGoodsDetail,
		trolleyAddTrolley,
		trolleyGetTrolleyByGoodsId,
		collectUserCollect,
    	mallActivityGetGroupLeaderList,
	} from '../../service/service';
	import dayjs from 'dayjs';
	import HeaderSearch from '../../components/header-search.vue';

	let timeTool = null;

	export default {
		components: {
			// 轮播新增 start
			Swiper,
			SwiperSlide,
			HeaderSearch,
			// 轮播新增 end
		},
		data() {
			return {
				// 轮播
				swiperOption: {
					loop: true,
					// 自动轮播
					autoplay: {
						delay: 2500,
						disableOnInteraction: false,
					},
					pagination: {
						el: '.swiper-pagination',
						// type: 'fraction', // 数子，注释掉是圆点
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				},

				//选项卡
				tabId: 0,
				tabList: [{
					title: "商品详细信息"
				}, {
					title: "商品评价"
				}],

				value: 3, //星星评分

				//选项卡
				navId: 0,
				navList: [{
					title: "桂花坚果藕粉羹【实发1罐500g】",
				}, {
					title: "坚果水果藕粉羹【实发1罐500g】",
				}, {
					title: "桂花坚果藕粉羹【拍1份发两罐  拍2份发5罐同款】",
				}, {
					title: "坚果水果藕粉羹【拍1份发两罐  拍2份发5罐同款】",
				}, {
					title: "坚果水果+桂花坚果[(拍1份发2罐)(拍2份发5罐,2罐坚果水果+3罐…",
				}],

				num: 1, //数量 


				//倒计时
				timeData: {},

				// 商品详情
				info: {
					id: 0,
				},
				// 秒杀
				seckill: '',
				// 拼团
				group: '',

				// 评论
				commentTotal: 0,
				commentList: [],
				page: 1,
				page_num: 20,
				commentImgList: [],

				// 规格
				itemList: {
					itemMap: {},
					itemIdMap: {},
					list: [],
				},
				// 每个规格选中的
				itemListSelect: {},
				// 当前选择的规格
				itemSelect: {},
				// 规格选择类型 addCart 加购物车 buy 购买
				selectType: '',

				// 数量
				num: 1,

				// 购物车
				cartNum: 0, // 总数量
				trolley: [], // 列表
				trolleyMap: {}, // 规格对应的购物车数量


				// 活动
				actId: 0,
				actType: 0, // 活动类型（0正常购买，1限时秒杀（抢购），2拼团,3折扣）
				groupLeaderList: [],

				// 倒计时
				countDown: 0,
				// 活动状态
				activeStatus: 0, // 0 活动未开始 1 正在抢购 -1 活动结束
			}
		},
		mounted() {
			const option = this.$route.query;
			const id = parseInt(option.id || 0);
			const actId = parseInt(option.actId || 0);
			const actType = parseInt(option.actType || 0);
			if (id > 0) {
				this.info.id = id;
				this.getGoodsDetail();
				this.getGoodsComment();
				this.getTrolleyByGoodsId();
			}
			if (actId > 0) {
				this.actId = actId;
				this.actType = actType;
				if (actType == 2) {
					this.getGroupLeaderList();
				}
			}
		},
		beforeDestroy() {
			clearTimeout(timeTool);
		},
		methods: {

			
			getCountDown() {
				const {start_time, end_time} = this.seckill;
				const start_timestamp = new Date(start_time).getTime();
				const end_timestamp = new Date(end_time).getTime();
				const current = new Date(dayjs().format('YYYY-MM-DD HH:mm:ss')).getTime();
				let status = 0; // 0 活动未开始 1 正在抢购 -1 活动结束
				let countDown = 0;
				if (current < start_timestamp) {
					status = 0;
					countDown = start_timestamp - current;
				} else if (current >= start_timestamp && current < end_timestamp) {
					// 抢购中
					status = 1;
					countDown = end_timestamp - current;
				} else if (current >= end_timestamp) {
					// 结束
					status = -1;
				}
				this.countDown = parseInt(countDown / 1000);
				this.activeStatus = status;
				if (timeTool) {
					clearTimeout(timeTool);
				}
				if (countDown > 0) {
					this.countDownFn();
				}
			},
			countDownFn() {
				const add0 = num => num < 10 ? `0${num}` : num;
				let countDown = this.countDown;
				// console.log(countDown);
				if (countDown <= 0) {
					this.getCountDown();
					return ;
				}
				timeTool = setTimeout(() => {
					if (--countDown < 0) {
						this.countDown = 0;
						this.timeData = { d: '00', s: '00', m: '00', h: '00' };
						clearTimeout(timeTool);
						return this.countDownFn();
					}
					const s = countDown % 60;
					const m = ((countDown - s) / 60 % 60);
					const h = ((countDown - s - m * 60) / 3600 % 24);
					const d = ((countDown - s - m * 60 - h * 3600) / 3600 / 24 % 365);
					this.countDown = countDown;
					this.timeData = { s: add0(s), m: add0(m), h: add0(h), d: add0(d) };
					this.countDownFn();
				}, 1000);
			},

			getGroupLeaderList() {
				const params = {
					act_id: this.actId,
					goods_id: this.info.id,
				};
				mallActivityGetGroupLeaderList(params).then(({ code, msg, data }) => {
					if (code == 1) {
						this.groupLeaderList = data.list;
					} else {
						this.$message.error(msg);
					}
				});
			},
			getGoodsDetail() {
				expediteGetGoodsDetail({
					goods_id: this.info.id
				}).then(({
					code,
					msg,
					data
				}) => {
					if (code == 1) {
						const info = data.goods_info;
						const itemList = info.item_list.reduce((a, b, index) => {
							const item = b.goods_spec.split(';;').map(i => i.split('::'));
							let idKey = '';
							if (index == 0) {
								item.forEach(([key, val]) => {
									this.itemListSelect[key] = val;
								});
								this.itemSelect = b;
							}
							item.forEach(([key, val]) => {
								a.itemMap[key] = [...(new Set([...(a.itemMap[key] || []), val]))];
								idKey += val;
							});
							a.itemIdMap[idKey] = b;
							return a;
						}, {
							itemMap: {},
							itemIdMap: {},
						});
						itemList['list'] = Object.entries(itemList.itemMap);
						data.goods_info.content_arr = data.goods_info.content.split('|').filter(item => item
							.length > 0);
						data.goods_info.effect_arr = data.goods_info.effect.split('|').filter(item => item.length >
							0);
						data.goods_info.goods_match_arr = data.goods_info.goods_match.split('|').filter(item =>
							item.length > 0);
						this.info = data.goods_info;
						// this.seckill = data.seckill;
						this.seckill = {start_time: '2022-05-29 16:50:00', end_time: '2022-05-29 17:30:00'};
						this.group = data.group;
						this.itemList = itemList;

						this.getCountDown();
					} else {
						this.$message.error(msg);
					}
				});
			},
			getGoodsComment(type = 0) {
				const params = {
					page: this.page,
					page_num: type == 1 ? 9999999 : this.page_num,
					goods_id: this.info.id,
					// create_at: "--",  // 时间
					// spec_id: "--",  // 规格id
					sort_type: 1, // 排序（1,时间，2商品评分，3物流评分，4服务评分）
					order_by: 2, // 排序规则（1升序，2降序）
					type, // 查询类型（0全部，1有图片）
				};
				expediteGetGoodsComment(params).then(({
					code,
					msg,
					data
				}) => {
					if (code == 1) {
						if (type == 1) {
							this.commentImgList = data.list.reduce((arr, item) => {
								const imagesArr = (item.images || '').split('|').filter(item => item
									.length > 0);
								return [...arr, ...imagesArr];
							}, []);
						} else {
							this.commentList = data.list.map(item => ({
								...item,
								user: item.user || {},
								imagesArr: (item.images || '').split('|').filter(item => item.length >
									0),
							}));
							this.commentTotal = data.total;
						}
					} else {
						this.$message.error(msg);
					}
				});
			},
			getTrolleyByGoodsId() {
				trolleyGetTrolleyByGoodsId({
					goods_id: this.info.id
				}).then(({
					code,
					msg,
					data
				}) => {
					if (code == 1) {
						this.trolley = data.list;
						this.trolleyMap = data.list.reduce((a, b) => ({
							...a,
							[b.spec_id]: b.spec_id
						}), {});
						this.cartNum = data.list.reduce((a, b) => a + b.num, 0);
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 收藏
			userCollect(id, first_classify) {
				const params = {
					coll_type: 1, // 类型（1商品2资讯3视频）
					coll_id: id, // 收藏id
					cate_id: first_classify, // 收藏分类id（多个分类传顶级分类id）
				}
				collectUserCollect(params).then(({
					code,
					msg
				}) => {
					if (code == 1) {
						this.getGoodsDetail();
						this.$message.success(msg);
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 加入购物车
			addCart() {
				const params = {
					goods_id: this.info.id, // 商品id
					spec_id: this.itemSelect.id, // 规格id
					num: Math.min(this.num, (this.itemSelect.stock - this.trolleyMap[this.itemSelect.id])),
				}
				trolleyAddTrolley(params).then(({
					code,
					msg,
					data
				}) => {
					if (code == 1) {
						this.getTrolleyByGoodsId();
						this.$message.success(msg);
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 购买
			buy() {
				const {
					actId,
					actType,
					num,
					itemSelect
				} = this;
				this.$router.push('/index/payment-order' +
					'?act_id=' + actId +
					'&act_type=' + actType +
					'&goods_id=' + itemSelect.goods_id +
					'&spec_id=' + itemSelect.id +
					'&num=' + num);
			},
			//限源预售-净含量-单选
			chooseItem(key, val) {
				this.itemListSelect[key] = val;
				const key2 = Object.values(this.itemListSelect).join('');
				this.itemSelect = this.itemList.itemIdMap[key2];
				this.num = Math.min(this.num, this.itemSelect.stock);
			},

			active(index) {
				this.active = index
			},
			//弹窗
			open() {
				this.$message({
					showClose: true,
					message: '添加成功，在购物车等您呦~',
					type: 'success',
					center: true,
					offset: 200,
					showClose: false
				});
			},
			// 获取元素到文档区域的坐标 
			handleMove: function(element) {
				for (var i = 0; i < showli.length; i++) {
					var showitem = showli[i];
					showitem.onmouseover = showitem.onclick = function(e) {
						let evt = window.event || e;
						for (var j = 0; j < showli.length; j++) {
							showli[j].className = "";
						}
						var showimg = this.getElementsByTagName("img")[0];
						var imgsrc = showimg.src;
						small.src = imgsrc;
						var bigsrc = showimg.getAttribute("data-img");
						big.src = bigsrc;
						this.className = "selected";
					}
				}

			},
			handleOut(evt) {
				content.onmousemove = function(e) {
					var evt = window.event || e;

					larger.style.display = "block";
					shadow.style.display = "block";
					var clientX = evt.clientX;
					var clientY = evt.clientY;

					var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
					var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

					var X = clientX + scrollLeft - chooseMarginL - shadowW / 2;
					var Y = clientY + scrollTop - chooseMarginT - shadowH / 2;

					if (X <= 0) {
						X = 0;
					}
					if (X >= maxX) {
						X = maxX;
					}
					if (Y <= 0) {
						Y = 0;
					}
					if (Y >= maxY) {
						Y = maxY;
					}
					//        防止遮罩层粘滞，跟随鼠标一起滑出大图位置
					var bigX = X * bigW / contentW;
					var bigY = Y * bigH / contentH;
					//  bigX / bigW = X / contentW,主图和遮罩层之间存在两倍关系，放大图和原图之间也有两倍关系
					shadow.style.left = X + "px";
					shadow.style.top = Y + "px";

					big.style.left = -bigX + "px";
					big.style.top = -bigY + "px";

				}
			},
			//跳转订单支付
			paymentOrder() {
				this.$router.push('/index/payment-order')
			},
			//跳转反馈
			feedback() {
				this.$router.push('/my/feedback')
			},
			//跳转视频专栏
			videoColumn() {
				this.$router.push('/index/video-column')
			},
			//跳转消息
			message() {
				this.$router.push('/my/message')
			},
			//跳转搜索
			search() {
				this.$router.push('/index/search')
			},
		}
	};
</script>
<!-- <style type="text/css">
	.wrap {
		background-color: #FFFFFF;
	}
</style> -->

<style scoped>
	.wrap {
		background-color: #FFFFFF;
	}
	.bb {
		width: 100%;
		border: 1px solid;
	}

	.swiper {
		width: 100%;
		height: 325px;
		margin: 0 auto 20px;
	}

	.swiper-pagination>>>.swiper-pagination-bullet {
		background: #fff !important;
		opacity: 1 !important;
	}

	.swiper-pagination>>>.swiper-pagination-bullet-active {
		opacity: 1;
		background: #F2501A !important;
	}

	.bannerImg {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding-top: 40px;
	}

	.container-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.content-width {
		width: 1200px;
		display: flex;
		flex-direction: column;
	}

	.top-module {
		width: 100%;
		height: 154px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: #FFFFFF;
		border-radius: 8px;
		padding: 0 13px;
		box-sizing: border-box;
		margin: 20px 0;
	}

	.top-leftsidebar {
		width: 226px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.top-middlesidebar {
		width: calc(100% - 536px);
		display: flex;
		flex-direction: column;
		margin: 0 10px;
	}

	.search-bar {
		width: 100%;
		height: 40px;
		border: 2px solid #F2501A;
		background-color: #FFFFFF;
		box-sizing: border-box;
		border-radius: 50px;
		display: flex;
		align-items: center;
	}

	.search-input {
		flex: 1;
		font-size: 12px;
	}

	.search-btn {
		width: 86px;
		height: 34px;
		line-height: 34px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50px;
		background-color: #F2501A;
		margin-right: 1.5px;
		color: #F8F8F8;
		font-size: 16px;
	}

	.placeholder {
		color: #919191;
	}

	.search-icon {
		width: 12px;
		height: 12px;
		margin-left: 12px;
		margin-right: 6px;
	}

	.tag-list {
		width: 100%;
		height: 50px;
		display: flex;
		flex-wrap: wrap;
		margin-top: 5px;
	}

	.tag-list>li {
		margin-right: 12px;
	}

	.tag-list>li>a {
		height: max-content;
		color: #505050;
		font-size: 12px;
	}

	.top-leftsidebar-top {
		display: flex;
		align-items: center;
	}

	.logo-img {
		width: 79px;
		margin-right: 21px;
	}

	.title-1 {
		width: 64px;
		margin-bottom: 15px;
	}

	.title-2 {
		width: 200px;
	}

	.top-rightsidebar {
		width: 290px;
		display: flex;
		align-items: flex-start;
	}

	.top-rightsidebar-btnBox {
		display: flex;
		align-items: center;
		margin-right: 23px;
	}

	.top-rightsidebar-btnBox button {
		width: max-content;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #505050;
		font-size: 12px;
		margin-right: 20px;
	}

	.top-rightsidebar-btnBox button:last-child {
		margin-right: 0;
	}

	.top-rightsidebar-btnBox button img {
		height: 22px;
		margin-bottom: 4px;
	}

	.code-wrap {
		height: 90px;
		display: flex;
		align-items: center;
	}

	.code-box {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #F2F2F2;
		border-radius: 4px;
		box-sizing: border-box;
		font-size: 9px;
		color: #F2501A;
		padding: 8px;
		margin-right: 20px;
	}

	.code-box:last-child {
		margin-right: 0;
	}

	.code-box>img {
		width: 60px;
		height: 60px;
		margin-bottom: 3px;
	}

	.tab-list {
		width: 100%;
		height: 49px;
		border-bottom: 1px solid #F2501A;
		box-sizing: border-box;
	}

	.tab-list>li {
		display: inline-block;
	}

	.tab-list>li>a {
		padding: 0 21px;
		height: 49px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #111111;
		font-size: 16px;
	}

	.tab-list>li.active>a {
		color: #FFFFFF;
		background-color: #F2501A;
		border-radius: 5px 5px 0 0;
	}

	.red-color {
		color: #F2501A !important;
	}

	.evaluation-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.evaluation-list>li {
		width: 100%;
		height: 244px;
		padding: 15px 0;
		display: flex;
		align-items: flex-start;
		border-bottom: 1px solid #E0E0E0;
		box-sizing: border-box;
	}

	.evaluation-list>li:last-child {
		border-bottom: none;
	}

	.evaluation-leftsidebar {
		width: 141px;
		margin-right: 10px;
		display: flex;
		flex-direction: column;
	}

	.evaluation-leftsidebar-top {
		width: 100%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 10px;
	}

	.people-avatar {
		width: 42px;
		height: 42px;
		border-radius: 50%;
		margin-right: 9px;
	}

	.people-name {
		color: #111111;
		font-size: 12px;
	}

	.date-time {
		color: #484848;
		font-size: 12px;
		margin-top: 10px;
	}

	.evaluation-rightsidebar {
		flex: 1;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.evaluation-msg {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #484848;
		font-size: 16px;
	}

	.img-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.img {
		width: 140px;
		height: 140px;
		object-fit: cover;
		border-radius: 5px;
		margin-right: 12px;
	}

	.evaluation-top {
		width: 100%;
		padding-top: 10px;
		display: flex;
		align-items: center;
	}

	.evaluation-num {
		width: 141px;
		margin-right: 10px;
		color: #111111;
		font-size: 15px;
		font-weight: bold;
	}

	.evaluation-tag-list {
		flex: 1;
		white-space: nowrap;
		overflow: auto;
	}

	.evaluation-tag-list>li {
		display: inline-block;
		width: max-content;
		background-color: #FBECE7;
		border: 1px solid #FDD0C9;
		border-radius: 50px;
		min-width: 86px;
		height: 28px;
		line-height: 28px;
		text-align: center;
		color: #F2501A;
		font-size: 14px;
		margin-right: 27px;
		padding: 0 11px;
		box-sizing: border-box;
	}

	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #999999;
		font-size: 13px;
		padding: 100px 0;
	}

	.normal-box>img {
		width: 40%;
		margin: 6px;
	}

	.box-end {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 37px 0;
	}


	.el-pagination.is-background>>>.btn-next,
	.el-pagination.is-background>>>.btn-prev,
	.el-pagination.is-background>>>.el-pager li {
		background-color: #fff !important;
	}

	.el-pagination.is-background>>>.el-pager li:not(.disabled).active {
		background-color: #F2501A !important;
		color: #FFF;
	}

	.el-pagination.is-background>>>.el-pager li:not(.disabled):hover {
		color: #F2501A !important;
	}

	.product-details-module {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.product-details-top {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		padding: 29px 20px 12px;
		box-sizing: border-box;
	}

	.product-details-row {
		width: 50%;
		display: flex;
		align-items: flex-start;
		margin-bottom: 10px;
	}

	.product-details-label {
		width: 61px;
		color: #111111;
		font-size: 12px;
		line-height: 22px;
		margin-right: 10px;
	}

	.product-details-msg-list {
		width: 60%;
		display: flex;
		flex-wrap: wrap;
	}

	.product-details-msg-list>span {
		line-height: 22px;
		color: #A7A7A7;
		font-size: 13px;
		margin-right: 19px;
	}

	.product-details-msg-list>span:last-child {
		margin-right: 0;
	}

	.product-details-msg-tag-list {
		width: 60%;
		display: flex;
		flex-wrap: wrap;
	}

	.product-details-msg-tag-list>span {
		border: 1px solid #E63D23;
		padding: 0 8px;
		width: max-content;
		height: 22px;
		line-height: 22px;
		display: flex;
		align-items: center;
		color: #F2501A;
		font-size: 12px;
		margin-right: 13px;
		border-radius: 50px;
	}

	.product-details-msg-tag-list>span:last-child {
		margin-right: 0;
	}

	.picture {
		width: 100%;
	}

	.red-color-border {
		border: 1px solid #E63D23;
		padding: 0 8px;
		width: max-content;
		height: 22px;
		line-height: 22px;
		display: flex;
		align-items: center;
		color: #F2501A;
		font-size: 12px;
		margin-right: 13px;
		border-radius: 50px;
	}

	.middle-module {
		width: 100%;
		display: flex;
		align-items: flex-start;
		padding-bottom: 50px;
	}

	.middle-leftsidebar {
		width: 422px;
		/* height: 519px; */
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		margin-right: 26px;
	}

	.middle-leftsidebar-top {
		width: 100%;
		height: 422px;
		box-sizing: border-box;
		border-radius: 8px;
		overflow: hidden;
		position: relative;
	}

	.seckill-module {
		width: 100%;
		height: 62px;
		display: flex;
		align-items: center;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.seckill-module-leftsidebar {
		width: calc(100% - 169px);
		height: 62px;
		display: flex;
		align-items: center;
		background: linear-gradient(90deg, #F58711, #E63D23);
		padding-left: 12px;
		box-sizing: border-box;
		color: #FFFFFF;
		font-size: 13px;
	}

	.seckill-price {
		min-width: 76px;
		height: 26px;
		line-height: 26px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 40px;
		color: #F32E02;
		font-size: 15px;
		background-color: #FFFFFF;
		margin-left: 6px;
	}

	.seckill-del-price {
		margin-left: 10px;
		text-decoration: line-through;
	}

	.seckill-module-rightsidebar {
		width: 169px;
		height: 62px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-color: #FFE7E7;
	}

	.seckill-label {
		color: #F32E02;
		font-size: 13px;
	}

	.countdown-wrap {
		display: flex;
		align-items: center;
	}

	.day-name {
		color: #F32E02;
		font-size: 13px;
		margin-right: 5px;
	}

	.countdown {
		display: flex;
		align-items: center;
		margin-top: 4px;
	}

	.countdown>span {
		width: 22px;
		height: 24px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #FC4A04;
		border-radius: 2px;
		color: #FFFFFF;
		font-size: 12px;
	}

	.countdown>span:nth-child(2),
	.countdown>span:nth-child(4) {
		width: 11px !important;
		background-color: initial !important;
		color: #F2501A !important;
		font-size: 16px !important;
	}

	.middle-leftsidebar-bottom {
		width: 100%;
		height: 75px;
		display: flex;
		align-items: center;
	}

	.middle-rightsidebar {
		width: 514px;
		display: flex;
		flex-direction: column;
	}

	.product-name {
		width: 100%;
		color: #111111;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 10px;
	}

	.card {
		width: 514px;
		height: 68px;
		background: url(../../assets/bg-21.png) no-repeat;
		background-size: 100% 100%;
		padding: 8px 11px 10px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		margin-bottom: 10px;
	}

	.card-row {
		flex: 1;
		display: flex;
		align-items: center;
		color: #111111;
		font-size: 12px;
	}

	.card-row-label {
		width: 57px;
		color: #777777;
		margin-right: 10px;
	}

	.card-row-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.card-row-price {
		color: #F2501A;
		font-size: 14px;
	}

	.card-row-price>span {
		font-size: 29px;
		font-weight: bold;
	}

	.return-box {
		min-width: 101px;
		height: 29px;
		background: url(../../assets/bg-22.png) repeat-x;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
	}

	.return-left {
		width: 52px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-weight: 500;
		color: #FFFFFF;
		font-size: 16px;
	}

	.return-right {
		padding: 0 5px 0 10px;
		box-sizing: border-box;
		text-align: center;
		font-weight: 500;
		color: #F2501A;
		font-size: 12px;
	}

	.return-right>span {
		font-size: 17px;
	}

	.address-module {
		border-bottom: 1px solid #DCDCDC;
		box-sizing: border-box;
		padding-bottom: 12px;
	}

	.address-label {
		width: 100%;
		color: #202020;
		font-size: 14px;
		margin-bottom: 7px;
	}

	.address-box {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.location-icon {
		width: 16px;
		margin-right: 17px;
	}

	.address-msg {
		color: #919191;
		font-size: 13px;
	}

	.courier {
		color: #F2501A;
		font-size: 13px;
		margin-left: 17px;
	}

	.radio-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-top: 9px;
	}

	.radio-label {
		width: 100%;
		color: #202020;
		font-size: 14px;
		margin-bottom: 10px;
	}

	.nav-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.nav-list>li {
		height: 32px;
		line-height: 32px;
		display: flex;
		align-items: center;
		width: max-content;
		padding: 0 9px;
		color: #777777;
		font-size: 11px;
		box-sizing: border-box;
		background-color: #F2F2F2;
		border: 1px solid #F2F2F2;
		margin-right: 11px;
		margin-bottom: 16px;
		border-radius: 50px;
	}

	.nav-list>li.active {
		color: #F2501A !important;
		border: 1px solid #E63D23 !important;
		background-color: #FDF9F6 !important;
	}

	.btn-box {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}

	.btn-box>button {
		height: 44px;
		line-height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px;
		margin-right: 22px;
		margin-bottom: 22px;
		font-size: 16px;
		border-radius: 5px;
		box-sizing: border-box;
	}

	.red-btn {
		width: 145px !important;
		background-color: #F2501A !important;
		color: #FFFFFF !important;
	}

	.border-red-btn {
		width: 96px !important;
		color: #F2501A !important;
		border: 1px solid #F2501A !important;
		background: rgba(242, 80, 26, 0.34) !important;
	}

	.orange-btn {
		width: 145px !important;
		background-color: #F28A1A !important;
		color: #FFFFFF !important;
	}

	.collect-icon {
		width: 18px;
		margin-right: 7px;
	}

	.tag-box {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 5px;
	}

	.tag-label {
		width: 80px;
		color: #202020;
		font-size: 14px;
	}

	.tag-rightsidebar {
		flex: 1;
		display: flex;
		flex-wrap: wrap;
	}

	.tag-rightsidebar>span {
		color: #A7A7A7;
		font-size: 13px;
		margin-right: 17px;
	}

	.box-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 17px;
	}

	.box-between-left {
		color: #202020;
		font-size: 14px;
	}

	.box-between-left>span {
		color: #777777;
		font-size: 12px;
	}

	.wrap>>>.el-input-number {
		width: 92px !important;
		line-height: 22px !important;
	}

	.wrap>>>.el-input::after {
		content: "" !important;
		width: 40px !important;
		height: 20px !important;
		position: absolute !important;
		left: 50% !important;
		top: 50% !important;
		transform: translate(-50%, -50%) !important;
		border-radius: 50px;
		background-color: #EEEEEE !important;
		z-index: 0 !important;
	}

	.wrap>>>.el-input-number__decrease,
	.wrap>>>.el-input-number__increase {

		top: 50% !important;
		transform: translate(0, -50%) !important;
		width: 22px !important;
		height: 22px !important;
		line-height: 22px !important;
		border-radius: 50% !important;
		border: none !important;
		z-index: 99999999 !important;
		color: #111111 !important;
		background: #EEEEEE !important;
	}

	.el-input-number>>>.el-input__inner {
		height: 22px !important;
		line-height: 22px !important;
		padding-left: 22px !important;
		padding-right: 22px !important;
		background-color: rgba(0, 0, 0, 0) !important;
		z-index: 999999 !important;
		color: #111111 !important;
		font-size: 13px !important;
		border: none !important;
		position: relative !important;
	}

	.wrap>>>.el-input-number__decrease,
	.wrap>>>.el-input-number__increase {
		font-size: 10px !important;
	}

	.big-img-box {
		width: 100%;
		height: 100%;
	}

	.big-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.small-img-list {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 0 25px;
		box-sizing: border-box;
		overflow: auto;
	}

	.small-img-list>li {
		margin-right: 11px;
	}

	.small-img-list>li>img {
		width: 75px;
		height: 75px;
		border-radius: 8px;
	}

	/*  */
	.choose {
		width: 400px;
		height: 600px;
		float: left;
		margin: 10px 0 0 10px;
	}

	.content {
		width: 400px;
		height: 400px;
		position: relative;
	}

	.content img {
		width: 400px;
		height: 400px;
	}

	#listshow {
		width: 400px;
		height: 100px;
		margin-top: 20px;
	}

	#listshow li {
		width: 98px;
		height: 100px;
		float: left;
		border: 1px solid #666;
	}

	#listshow li img {
		width: 98px;
		height: 100px;
	}

	#listshow .selected {
		border-color: brown;
	}

	.larger {
		width: 400px;
		height: 400px;
		position: absolute;
		top: 70px;
		left: 460px;
		float: left;
		overflow: hidden;
		display: none;
	}

	.larger img {
		width: 800px;
		height: 800px;
		position: absolute;
		left: 0;
		top: 0;
	}

	.shadow {
		width: 200px;
		height: 200px;
		background-color: rgba(145, 200, 200, 0.4);
		position: absolute;
		left: 0;
		top: 0;
		z-index: 10;
		display: none;
	}

	/* 无数据css */
	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #999999;
		font-size: 13px;
		padding: 100px 0;
	}

	.normal-box>img {
		width: 40%;
		margin: 6px;
	}

	/* 拼团 */
	.group-module {
		width: 100%;
		display: flex;
		flex-direction: column;
		border-radius: 8px;
		background-color: #FFFFFF;
		margin-bottom: 29px;
		box-shadow: 0 3px 6px #eee;
		padding: 10px 11px;
		box-sizing: border-box;
	}

	.group-module-top {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #202020;
		font-size: 18px;
		padding: 16px 0 0;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.group-msg-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.group-msg-item {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #F2F2F2;
		padding: 10px 0;
		box-sizing: border-box;
	}

	.group-msg-item:last-child {
			border-bottom: none !important;
	}

	.group-msg-sidebar {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.group-user-img {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		margin-right: 20px;
	}

	.group-user-name {
		color: #070707;
		font-size: 16px;
	}

	.group-btn {
		color: #FFFFFF;
		font-size: 16px;
		width: 122px;
		height: 40px;
		line-height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50px;
		background-color: #F2501A;
	}
</style>
